import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Pane from 'components/Common/Pane'
import config from 'constants/config'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'LuxKit/Typography/Heading'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import LayoutContainer from 'components/Common/LayoutContainer'

const SummaryPlaceholder = styled(Pane)`
  height: ${rem(500)};
`

const PackageOptionsPlaceholder = styled(Pane)`
  height: ${rem(700)};
  padding: ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(24)} ${rem(40)};
  }

  ${mediaQueryUp.desktop} {
    padding: ${rem(62)} ${rem(12)};
  }
`

const OfferHeaderPlaceholder = styled(Pane)`
  display: flex;
  height: ${rem(64)};
  position: sticky;
  z-index: 3;
  top: 0;

  ${mediaQueryUp.desktop} {
    height: ${rem(60)};
  }
`

const ImagePlaceholder = styled(LoadingBox)`
  aspect-ratio: 3 / 2;

  ${mediaQueryUp.tablet} {
    aspect-ratio: 16 / 9;
  }
`

function OfferContentLoader() {
  const intl = useIntl()

  return (
    <div>
      <OfferHeaderPlaceholder />
      <Pane>
        <LayoutContainer>
          <ImagePlaceholder />
        </LayoutContainer>
      </Pane>
      <SummaryPlaceholder />
      <PackageOptionsPlaceholder background="light-background">
        <Heading variant="heading3" format="titlecase" align="center" colour="normal-contrast">
          {intl.formatMessage(
            {
              id: 'YylXaXhXXD8iJTpYxNAZ',
              defaultMessage: '{travelSynonym} Options',
              description: 'Heading for package options section on offer page loader',
            },
            { travelSynonym: config.brandConfig.travelSynonym },
          )}
        </Heading>
      </PackageOptionsPlaceholder>
    </div>
  )
}

export default OfferContentLoader
